import {FileDownload as FileDownloadIcon} from '@mui/icons-material';
import {useLocation} from 'react-router-dom';

import useReport from '../../../hooks/providers/useReport';
import HeaderStyledIconButton from '../HeaderStyledIconButton/HeaderStyledIconButton';

const HeaderExportReportButton = () => {
  const {setIsReportExportTypeChoiceModalOpen, isReportInEditionMode, allReportVisuals, isReportLoaded} = useReport();

  const location = useLocation();

  const handleIconClick = async () => {
    setIsReportExportTypeChoiceModalOpen(true);
  };

  const isReportPage = location?.pathname?.startsWith('/reports');
  if (!isReportPage || isReportInEditionMode || allReportVisuals.length === 0 || !isReportLoaded) {
    return null;
  }

  return (
    <HeaderStyledIconButton onClick={handleIconClick}>
      <FileDownloadIcon />
    </HeaderStyledIconButton>
  );
};

export default HeaderExportReportButton;
